/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { budgetsDeleteTeamDefault } from "../../funcs/budgetsDeleteTeamDefault.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.DeleteTeamDefaultBudgetRequest$inboundSchema,
};

export const tool$budgetsDeleteTeamDefault: ToolDefinition<typeof args> = {
  name: "budgets-delete-team-default",
  description: `Delete a per-team default budget

Removes the org's per-team default budget for the given owner; only explicit team budgets remain. Targets the caller's own organization (inferred from the API key or session) unless the optional org_id query parameter names another org — cluster admins only. Callable by cluster admins, or org admins for their own organization (owner=org).`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await budgetsDeleteTeamDefault(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
